
import AppLink from "./AppLink"

export default {
  components: {
    AppLink
  },
  props: {
    reviewTitle: {
      type: String,
      required: true
    },
    reviewDescription: {
      type: String,
      required: true
    },
    authorName: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: null
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    noBackground: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    verified: {
      type: Boolean,
      default: false
    },
    largeSize: {
      type: Boolean,
      default: false
    }
  }
}
